"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXCHANGE_RATE_NAME_TO_CURRENCY = void 0;
const enums_1 = require("../enums");
exports.EXCHANGE_RATE_NAME_TO_CURRENCY = {
    [enums_1.ExchangeRateName.OKLP_USDT]: {
        sell: enums_1.SystemCurrency.USDT,
        buy: enums_1.SystemCurrency.OKLP,
    },
    [enums_1.ExchangeRateName.USDT_OKLP]: {
        sell: enums_1.SystemCurrency.OKLP,
        buy: enums_1.SystemCurrency.USDT,
    },
};
//# sourceMappingURL=exchange-rate-name-to-currency.js.map